import React from 'react';
import { useTheme } from '../hooks/useTheme';
import { AppearanceTypographyContext } from './AppearanceContext';
export default function AppearanceTypographyProvider({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  return <AppearanceTypographyContext.Provider value={theme.typography}>{children}</AppearanceTypographyContext.Provider>;
}
